module.exports = __webpack_public_path__ + "7f2d7b492511473c1f1e271a395d05ee.png";